import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { TrackingProductModel } from "@omni/types/components/tracking/models/trackingProduct.model";
import { AddToWishlishtTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/addToWishlist.trackingInfo";

import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: AddToWishlishtTrackingInfo) => {
    const event: AnalyticsEvent<AddToWishlishtTrackingInfo> = {
        event: EventType.AddToWishlist,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackProduct = (product: TrackingProductModel) => {
    track(product);
};
